

import React from "react"
import FlexView from "react-flexview/lib";
import { getSvg } from "../Core/Hull/EquipmentView";

export const HullItemSelectView = (props) => {

    return (<FlexView vAlignContent={'center'}>
        {getSvg(props.type.getSvgName(), !props.size ? 'medium' : props.size)}
        <div className="text-body black margin-left-6">{props.type.name}</div>
    </FlexView>)

}